import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import API from '@Services/apiAxios';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export interface Warehouse {
  _id: string;
  company_name: string;
  id: string;
}

export interface WarehouseResponse {
  msg: string;
  isError: boolean;
  isFetched: boolean;
  data: {
    list: Warehouse[];
  };
  totalCount: number;
}

export const CSBTypeOptions: DropdownOptionType[] = [
  { value: 'csb4', display: 'CSB4' },
  { value: 'csb5', display: 'CSB5' },
];

export const TermsOfInvoiceOptions: DropdownOptionType[] = [
  { value: 'ddu', display: 'DDU' },
  { value: 'ddp', display: 'DDP' },
];

export const TaxPaymentOptions: DropdownOptionType[] = [
  { value: 'NA', display: 'N/A' },
  { value: 'Against Bond', display: 'Against Bond' },
  { value: 'Under taking', display: 'Under Taking' },
  { value: 'IGST', display: 'IGST' },
];

export const IsHavingBatteryOptions: DropdownOptionType[] = [
  { value: 'yes', display: 'Yes' },
  { value: 'no', display: 'No' },
];
export const batteryTypeOptions: DropdownOptionType[] = [
  { value: 'Lithium Ion Alloy', display: 'Lithium Ion Alloy' },
  { value: 'Lithium Ion Polymer', display: 'Lithium Ion Polymer' },
];
export const batteryPackingOptions: DropdownOptionType[] = [
  { value: 'Inside Equipment', display: 'Inside Equipment' },
  { value: 'Packaged with Equipment', display: 'Packaged with Equipment' },
  { value: 'Battery Only', display: 'Battery Only' },
];

export const PickupAddressOptions: DropdownOptionType[] = [{ value: '39898', display: 'Testing Pickup Address' }];

export const getWarehouses = async (accountNo: string): Promise<DropdownOptionType[]> => {
  try {
    const response = await API.get<WarehouseResponse>(
      `/shipment/vendor/ithinklogistics/warehouses?accountNo=${accountNo}`,
    );

    const warehouses = response.data.data.list;

    const PickupAddressOptions: DropdownOptionType[] = warehouses.map(item => ({
      value: item.id,
      display: `${item.id} - ${item.company_name}`,
    }));

    return PickupAddressOptions;
  } catch (error) {
    console.error('Failed to fetch warehouses', error);
    return [];
  }
};

export const addWarehouse = async (props: { accountNo: string; shipmentNumber: string }): Promise<void> => {
  try {
    const response = await API.post(`/shipment/vendor/ithinklogistics/addwarehouses/${props?.shipmentNumber}`, {
      accountNo: props.accountNo,
    });

    if (response.data.isError) {
      throw new Error(response.data.msg);
    }

    console.log('Warehouse added successfully:', response.data.msg);
  } catch (error) {
    console.error('Failed to add warehouse', error);
    throw error;
  }
};

export const thinkLogisticsInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  csb_type: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('CSB Type is required'),
  terms_of_invoice: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Terms of invoice is required'),
  tax_payment_option: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Tax payment is required'),
  is_having_battery: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Is having battery is required'),
  pickup_address_id: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Warehouse address is required'),
  // Conditional validation for battery fields
  battery_packing: Yup.string().when('is_having_battery', {
    is: 'yes',
    then: schema => schema.required('Battery packing is required'),
    otherwise: schema => schema.notRequired(),
  }),
  battery_type: Yup.string().when('is_having_battery', {
    is: 'yes',
    then: schema => schema.required('Battery type is required'),
    otherwise: schema => schema.notRequired(),
  }),
  HSNCode: Yup.string().required('HSNCode is required'),
});

export interface ThinkLogisticsInformationSchema {
  type: string;
  csp: string;
  accountNo: string;
  pickup_address_id: string;
  csb_type: string;
  terms_of_invoice: string;
  tax_payment_option: string;
  is_having_battery: string;
  awbShowToUser: boolean;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: ThinkLogisticsInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'ithinklogistics';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
